<template>
    <div class="offer_item_price">
        <div
            class="offer_item_price_item"
            v-for="item in fList"
            :key="item.Id"
            @click="goDetails(item.Title)"
        >
            <div class="price_title">
                {{ item.Title }}
            </div>

            <div class="price_float" :class="item.classColor">
                <div class="price_float_one">
                    {{ item.value.toFixed(1) }}
                </div>

                <div class="price_float_two">
                    {{ item.changeString }}
                </div>

                <div class="price_float_three">
                    {{ Math.abs(item.changeValue1 - 0).toFixed(1) }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "PriceItem",

    props: {
        list: {
            type: Array,
            default: () => [],
        },
        sortObj: {
            type: Object,
            default: () => {},
        },
    },

    computed: {
        fList() {
            let newList = this.list.map((item) => {
                const data = {
                    ...item,
                };

                if (data.classColor == "green") {
                    data.changeString = "↓";
                } else if (data.classColor == "red") {
                    data.changeString = "↑";
                } else {
                    data.changeString = "丨";
                }

                return data;
            });
            // console.log("newList------------", newList);

            newList = newList.sort((a, b) => {
                const aSort = this.sortObj[a.Title] || 999;
                const bSort = this.sortObj[b.Title] || 999;

                return aSort - bSort;
            });

            const arr = [];
            const len = Math.ceil(newList.length / 4); // 1
            const cow = newList.length % 4; // 0
            let sliceLen = 0;
            for (let i = 0; i < 4; i++) {
                let addLen = sliceLen + len;

                if (i >= cow && cow > 0) {
                    addLen -= 1;
                }
                // console.log(i, sliceLen, addLen);

                arr.push(newList.slice(sliceLen, addLen));
                sliceLen = addLen;
            }
            // console.log(newList.length, len, cow, arr);

            const nList = [];
            for (let i = 0; i < len; i++) {
                const pushList = [];
                for (let j = 0; j < arr.length; j++) {
                    if (arr[j][i]) {
                        pushList.push(arr[j][i]);
                    }
                }

                nList.push(...pushList);
            }

            if (newList.length != nList.length) {
                console.log(nList);
            }

            return nList;
        },
    },

    data() {
        return {};
    },
    created() {},

    methods: {
        goDetails(title) {
            // console.log(title)
            this.$router.push({
                path: "/details",
                query: {
                    title,
                    type: 0,
                },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.offer_item_price {
    width: 100%;

    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;

    box-sizing: border-box;

    .offer_item_price_item {
        width: 25%;
        height: 42px;

        box-sizing: border-box;

        padding: 9px 8px;

        border-right: 1px solid #c8c8c8 !important;
        border-bottom: 1px solid #c8c8c8;

        display: flex;
        align-items: center;
        justify-content: space-between;

        font-size: 15px;
        font-weight: bold;
        color: #000;
        cursor: pointer;

        .price_title {
            width: 54%;

            text-align: left;

            overflow: hidden;
        }

        .price_float {
            width: 46%;
            display: flex;

            .price_float_one {
                width: 50%;
            }

            .price_float_two {
                width: 15px;

                margin: 0 4px;
                text-align: center;
            }

            .price_float_three {
                flex: 1;
            }
        }
    }
}
</style>
